var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21583 14.3999C4.55615 14.3999 4.83204 14.6892 4.83204 15.0461V25.1076H25.1672V15.0461C25.1672 14.6892 25.4431 14.3999 25.7834 14.3999C26.1237 14.3999 26.3996 14.6892 26.3996 15.0461V25.7537C26.3996 26.1106 26.1237 26.3999 25.7834 26.3999H4.21583C3.8755 26.3999 3.59961 26.1106 3.59961 25.7537V15.0461C3.59961 14.6892 3.8755 14.3999 4.21583 14.3999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.025 8.22437C18.7907 8.45868 18.4108 8.45867 18.1765 8.22435L15.6008 5.64851V21.0001C15.6008 21.3315 15.3322 21.6001 15.0008 21.6001C14.6694 21.6001 14.4008 21.3315 14.4008 21.0001V5.64874L11.825 8.22437C11.5907 8.45868 11.2108 8.45867 10.9765 8.22435C10.7422 7.99003 10.7422 7.61013 10.9765 7.37582L14.5683 3.78419C14.6775 3.67071 14.8309 3.6001 15.0008 3.6001C15.059 3.6001 15.1152 3.60838 15.1684 3.62383C15.2624 3.65106 15.3511 3.70173 15.4252 3.77584L19.0251 7.37584C19.2594 7.61016 19.2594 7.99006 19.025 8.22437Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.68d48212caaadcb1600711d110460f7e.svg";
export { ForwardRef as ReactComponent };